import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { useLanguage } from "../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import { LuTrash2 } from "react-icons/lu";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const SettingsGeoModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
    setGeoData,
    geoData,
    setOpenDeleteGeo
}) => {
    const { t } = useLanguage()
    const { org_id } = useParams()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const handleChange = (e) => {
        setGeoData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {
        if (!geoData.name.trim()) {
            setErrorMessage({ message: t.geo.name_required, display: true });
            return;
        }

        if (!geoData.description.trim()) {
            setErrorMessage({ message: t.geo.desc_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/update_geo_optimization`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    geo_id: geoData.id,
                    name: geoData.name,
                    description: geoData.description,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                fetchRecords()
                closeModal()
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const handleDelete = () => {
        setOpenDeleteGeo(true)
        closeModal()
    }

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.geo.update_title}</p>
                <button className="context_window_footer_btn_delete fade-in" onClick={handleDelete}><LuTrash2 /></button>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            value={geoData.name}
                            onChange={handleChange}
                            placeholder={t.geo.title_placeholder}
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            {t.description} <MandatorySign message={t.mandatory_field} />
                        </label>
                        <textarea
                            name="description"
                            maxLength={300}
                            value={geoData.description}
                            onChange={handleChange}
                            placeholder={t.geo.description_placeholder}
                            className="register_form_first textarea_reg fade-in"
                            autoComplete="off"
                        />
                    </div>

                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SettingsGeoModal;